import React from 'react';
function LeadsPage() {
  return <h1>Lades Page</h1>;
}
export default LeadsPage;